// extracted by mini-css-extract-plugin
export var resumeSamplesTwoCol = "success-stories-module--resume-samples-two-col--4e26e";
export var textColumnHowWeHelped = "success-stories-module--text-column-how-we-helped--c6dc1";